<template>
  <button @click="click" class="button-back">
    <slot>
      Zurück zur Übersicht
    </slot>
  </button>
</template>

<script setup>
import { usePodcastsRouter } from '@/router/routers';

const router = usePodcastsRouter();
const click = () => router.show()

</script>
